import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    descriptionInvitation:
      'The team member {firstName} {lastName} is already having a pending invitation. Wait until this member redeems his invitation, or cancel the invitation at all.',
    descriptionLocked:
      'The team member {firstName} {lastName} is revoked. By modifying his role, he will also be re-invited.',
    descriptionLockedWithInvitation:
      'The team member {firstName} {lastName} is revoked. Go to the member list to re-invite him and wait until this member redeems his invitation, or cancel the invitation at all.',
    descriptionUser:
      'The team member {firstName} {lastName} is already using this email address. You may edit his role.',
    editRoleAction: 'Edit role',
    goBack: 'Go back to team members',
    goBackToRevokedList: 'Go to revoked team members',
    inviteToANewRole: 'Invite back for a new role',
    title: 'This email has already been used',
  },
  fr: {
    descriptionInvitation:
      "Le membre {firstName} {lastName} a déjà une invitation en attente. Attendez que ce membre utilise son invitation, ou annulez complètement l'invitation.",
    descriptionLocked:
      'Le membre {firstName} {lastName} est révoqué. En modifiant son rôle, il sera aussi ré-invité.',
    descriptionLockedWithInvitation:
      "Le membre {firstName} {lastName} est révoqué. Accédez à la liste des membres pour le réinviter et attendez que ce membre utilise son invitation, ou annulez complètement l'invitation.",
    descriptionUser:
      'le membre {firstName} {lastName} utilise déjà cette adresse email. Si vous le souhaitez vous pouvez modifier son rôle.',
    editRoleAction: 'Modifier le rôle',
    goBack: "Retourner à la liste des membres d'équipe",
    goBackToRevokedList: "Accéder aux membres d'équipe révoqués",
    inviteToANewRole: 'Inviter de nouveau pour un nouveau rôle',
    title: 'Cette adresse email a déjà été utilisée',
  },
} as const);

export default locales;
